import React, { Component } from 'react';

import JItem from './jitem'
import * as func from "../../../../../utils/functions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from "../../../../../store/modules/journals";
import JournalItem from "../../list/item";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";
import * as FActions from "../../../../../store/modules/footer";

class JAdminSide extends Component {
  constructor(props) {
    super(props);

    if (location.search.substring(1)) {
      this.props.dataActions.setJournals({'param': func.parseParams(location.search.substring(1))});
    }
    // 이해 안됨.
    setTimeout(() => {
      this.getList();
    }, 0);

    this.showMessage = this.showMessage.bind(this)
  }

  getList() {
    let param = this.props.param;
    param.records_per_page = 10;

    func.getData("admin/journals", param).then((response) => {
      this.props.dataActions.setJournals(response);
    });
  }

  handlePageClick = (page) => {
    const paged = page.selected + 1;

    let param = this.props.param;
    param.records_per_page = 10;
    param['current_page'] = paged;

    func.getData("journals", param).then((response) => {
      this.props.dataActions.setJournals({"param": param});
      const url = objectToQueryString(param);
      pushUrl('검색', "admin.php?page=journal&record_id=" + func.getParams("record_id") + '&' + url, this.props.param);
      this.props.dataActions.setJournals(response);
    });
  }

  showMessage(message) {
    console.log('??')
    this.props.fDataActions.setFooter({
      'isNoticePopup': true,
      'noticeMessage': message
    })
    setTimeout(() => {
      this.props.fDataActions.setFooter({
        'isNoticePopup': false,
        'noticeMessage': ''
      })
    }, 3000);
  }

  render() {
    const {records} = this.props;

    return (
      <>
        <h6 className="mt-2">Journal List</h6>
        <table className="table table-striped table-thin border-bottom mt-1">
          <colgroup>
            <col width="50px"/>
            <col width=""/>
            <col width="60px"/>
          </colgroup>
          <thead>
            <tr>
              <th scope="col">NO</th>
              <th scope="col">저널명</th>
              <th scope="col">상태</th>
            </tr>
          </thead>
          <tbody>
          {records.map((record, index) => {
            const no = this.props.totalRecords - ((this.props.param.current_page - 1) * this.props.param.record_per_page) - index;
            return (
              <JItem key={record.journal_id} record={record} no={no} showMessage={this.showMessage} />
            )
          })}
          </tbody>
        </table>
        {this.props.totalPage > 1 &&
        <div className="mt-4">
          <div>
            <div className="paging-wrap">
              <ReactPaginate
                forcePage={Number(this.props.param.current_page) - 1}
                pageCount={this.props.totalPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={this.handlePageClick}
                previousLabel="<"
                nextLabel=">"
                containerClassName={'pagination'}
                activeClassName={'active'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item page-item-prev'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item page-item-next'}
                nextLinkClassName={'page-link'}
              />
            </div>
          </div>
        </div>
        }
      </>
    )
  }
}


export default connect(
  (state) => ({
    param: state.journals.param ? state.journals.param : {},
    records: state.journals.records ? state.journals.records : [],
    totalRecords: state.journals.totalRecords ? state.journals.totalRecords : 0,
    totalPage: state.journals.totalPage ? state.journals.totalPage : 0,
  }),
  (dispatch) => ({
    dataActions: bindActionCreators(Actions, dispatch),
    fDataActions: bindActionCreators(FActions, dispatch)
  }),
)(JAdminSide)

JAdminSide.propTypes = {
  // args : PropTypes.object,
  // facet : PropTypes.object,
};
